// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DXW6","clinicsSelect":"styles_clinicsSelect__1RW6c"};